import React from 'react';

import { ErrorBoundary } from '@nxte-nl/error-boundary';
import { stateHooks } from '@nxte-nl/state-hooks';

import { AccountNavigation } from '../../components/AccountNavigation/AccountNavigation';
import { accountLoginHooks } from '../../hooks/accountLoginHooks/accountLoginHooks';
import { featureStateHooks } from '../../hooks/featureStateHooks/featureStateHooks';
import { messageHooks } from '../../hooks/messageHooks/messageHooks';
import { AccountMessages } from '../../types/Messages';

export type Props = {
  isHeaderV2?: boolean;
  pageLoading?: boolean;
};

export const AccountNavigationContainer = (props: Props) => {
  const { pageLoading, isHeaderV2 } = props;

  const {
    value: isOpened,
    toggle: onToggle,
    setFalse: onClose,
  } = stateHooks.useBooleanState({ initialState: false });

  const { isNavigationIconTextOn } = featureStateHooks.useFeatureToggles();

  const userInfo = messageHooks.useSubjectState(AccountMessages.AccountUserInfo);
  const isUserLoggedIn = Boolean(userInfo?.user);
  const isAccountLink = Boolean(userInfo && !userInfo.user);
  const { handleLogoutUser, loading } = accountLoginHooks.useLogoutUser(onClose);

  return (
    <ErrorBoundary>
      <AccountNavigation
        isNavigationIconTextOn={isNavigationIconTextOn}
        isUserLoggedIn={isUserLoggedIn}
        isAccountLink={isAccountLink}
        pageLoading={pageLoading}
        logoutLoading={loading}
        isOpened={isOpened}
        onLogoutUser={handleLogoutUser}
        onToggle={onToggle}
        onClose={onClose}
        isHeaderV2={isHeaderV2}
      />
    </ErrorBoundary>
  );
};

AccountNavigationContainer.displayName = 'AccountNavigationContainer';
